export const testimonialTranslations = {
  TESTIMONIAL_HEADER: 'What our customers say about tranzer'
}
